<template lang="pug">
div
  .md-form-group
    label Search
    input(
      type="text"
      name="search"
      v-model="search"
      class="form-control"
      @input="onFiltersChange"
    )

  .md-form-group
    label Region
    multiselect(
      :loading="onLoading('fetch-region')"
      name="regions"
      deselect-label=""
      label="name"
      select-label=""
      track-by="id"
      v-model="region"
      :close-on-select="false"
      :hide-selected="true"
      :multiple="true"
      :options="regions"
      @input="onFiltersChange"
      @search-change="refreshRegionList"
    )

  .md-form-group
    label Trading Area
    multiselect(
      :loading="onLoading('fetch-trading-area')"
      name="trading_areas"
      deselect-label=""
      label="name"
      select-label=""
      track-by="id"
      v-model="trading_area"
      :close-on-select="false"
      :hide-selected="true"
      :multiple="true"
      :options="trading_areas"
      @input="onFiltersChange"
      @search-change="refreshTradingAreaList"
    )

  .md-form-group
    label Zone
    multiselect(
      :loading="onLoading('fetch-zone')"
      name="zones"
      deselect-label=""
      label="name"
      select-label=""
      track-by="id"
      v-model="zone"
      :close-on-select="false"
      :hide-selected="true"
      :multiple="true"
      :options="zones"
      @input="onFiltersChange"
      @search-change="refreshZoneList"
    )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ZoneMixin from '@js/mixins/zone';
import RegionMixin from '@js/mixins/region';
import TradingAreaMixin from '@js/mixins/trading_area';

export default {
    mixins: [ZoneMixin, RegionMixin, TradingAreaMixin],

    props: {
        updateFilters: {
            type: Function,
            required: true,
        },
        onAddAllChange: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            addAll: false,
            region: [],
            zone: [],
            trading_area: [],
            search: null,
        };
    },
    computed: {
        ...mapGetters('zone', ['zones']),
        ...mapGetters('tradingArea', ['trading_areas']),
        ...mapGetters('region', ['regions']),
    },
    created() {
        this.getTradingAreaListIfNecessary();
        this.getZoneListIfNecessary();
        this.getRegionListIfNecessary();
    },
    methods: {
        resetFilters() {
            this.region = [];
            this.zone = [];
            this.trading_area = [];
            this.search = null;
            this.addAll = false;
            this.updateFilters({
                regions: this.region,
                zones: this.zone,
                trading_area: this.trading_area,
                search: this.search,
            });
        },
        onFiltersChange: _.debounce(function(query) {
            this.updateFilters({
                regions: this.region,
                zones: this.zone,
                trading_area: this.trading_area,
                search: this.search,
            });
        }, 500),
        ...mapActions('zone', ['getZones']),
        ...mapActions('tradingArea', ['getTradingAreas']),
        ...mapActions('region', ['getRegionList']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/promotion/templates/filter-sidebar.vue